module.exports = __webpack_public_path__ + "img/fz-4.d755dc23.png";